import get from 'lodash/get';
import {Reducer} from 'redux';

import {DataDefinition} from 'client/models/data-definitions/types';

import types from './types';

type GameStore = {
  dataDefinitions: DataDefinition[];
};

const initialState: GameStore = {
  dataDefinitions: [],
};

const reducer: Reducer<GameStore> = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_DATA_DEFINITIONS_SUCCESS:
      return {
        ...state,
        dataDefinitions: get(action, 'payload.data_definitions', initialState.dataDefinitions),
      };

    default:
      return state;
  }
};

export default reducer;
